module.exports = __webpack_public_path__ + "img/data-icon-4.f68a2af5.png";